import { MdOutlineDeleteOutline } from 'react-icons/md'

import { Button } from '~/components/Buttons'
import ThumbProduct from '~/components/ThumbProduct'
import i18n from '~/i18n'
import Image from '~/modules/retailMedia/components/BannersTable/TumbProduct'

const handleDeleteAsset = (data: AssetsReady) => {
  data.handleDeleteAsset(data)
}
export const schema: TableSchema<AssetsReady> = {
  image: {
    title: i18n.t('rm:media'),
    render: rowData => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Image url={rowData?.media_url}>
          <ThumbProduct url={rowData?.media_url} />
        </Image>
      </div>
    )
  },
  type: {
    title: i18n.t('rm:mediaType'),
    render: rowData => rowData.type,
    width: '120px'
  },
  mediaSize: {
    title: i18n.t('rm:mediaSize'),
    render: rowData => (
      <div style={{ lineHeight: 1 }}>
        <strong className="title">
          <code>
            {rowData?.dimensions?.width} x {rowData?.dimensions?.height}
          </code>
        </strong>
      </div>
    ),
    className: 'order__details col__infos col__title',
    width: '130px'
  },
  actions: {
    width: '180px',
    render: rowData => (
      <div className="text-align-right">
        <Button
          onClick={() => handleDeleteAsset(rowData)}
          template="transparentCritical"
          size="xsmall"
          iconLeft={<MdOutlineDeleteOutline />}
          text={i18n.t('c:actions.removeMedia')}
        />
      </div>
    )
  }
}
